export const mobileApp_ru = {
    head: "Мобильное",
    headStrong: "приложение",
    desc1: "Скачайте и установите приложение CleVR для мобильной и быстрой работы с вашим аккаунтном. Редактируйте, создавайте стенды и назначайте встречи с ваших корманных гаджетов.",
    desc2: "С приложением CleVR всегда под рукой!",
}